
// @ts-nocheck
import locale_kk_46json_a5d36579 from "#nuxt-i18n/a5d36579";
import locale_ru_46json_f9c37154 from "#nuxt-i18n/f9c37154";
import locale_en_46json_0b63539c from "#nuxt-i18n/0b63539c";

export const localeCodes =  [
  "kk",
  "ru",
  "en"
]

export const localeLoaders = {
  kk: [
    {
      key: "locale_kk_46json_a5d36579",
      load: () => Promise.resolve(locale_kk_46json_a5d36579),
      cache: true
    }
  ],
  ru: [
    {
      key: "locale_ru_46json_f9c37154",
      load: () => Promise.resolve(locale_ru_46json_f9c37154),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_46json_0b63539c",
      load: () => Promise.resolve(locale_en_46json_0b63539c),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "kk",
      name: "Қазақша",
      files: [
        {
          path: "/app/i18n/locales/kk.json",
          cache: undefined
        }
      ]
    },
    {
      code: "ru",
      name: "Руский",
      files: [
        {
          path: "/app/i18n/locales/ru.json",
          cache: undefined
        }
      ]
    },
    {
      code: "en",
      name: "English",
      files: [
        {
          path: "/app/i18n/locales/en.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "ru",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_except_default",
  lazy: false,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "kk",
    name: "Қазақша",
    files: [
      {
        path: "/app/i18n/locales/kk.json",
        cache: undefined
      }
    ]
  },
  {
    code: "ru",
    name: "Руский",
    files: [
      {
        path: "/app/i18n/locales/ru.json",
        cache: undefined
      }
    ]
  },
  {
    code: "en",
    name: "English",
    files: [
      {
        path: "/app/i18n/locales/en.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/